import _get from "lodash/get";
import styled from 'styled-components';
import { DialogOverlay } from '@reach/dialog';
import modalTheme from '../../styles/modalTheme';
var ModalOverlay = styled(DialogOverlay).withConfig({
  displayName: "ModalOverlay",
  componentId: "jr0mzk-0"
})(["background-color:", ";bottom:0;left:0;overflow:auto;position:fixed;right:0;top:0;z-index:", ";"], function (_ref) {
  var theme = _ref.theme,
      $isOverlayTransparent = _ref.$isOverlayTransparent;
  return $isOverlayTransparent ? 'transparent' : _get(theme, 'modal.overlay.color', modalTheme.modal.overlay.color);
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'modal.overlay.zIndex', modalTheme.modal.overlay.zIndex);
});
export default ModalOverlay;